import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Typography } from '@mui/material';
import STRING_KEYS from '../../../language/keys';
import style from './style';

type TableCountRowType = {
  count: number,
  colSpan: number,
  text: string,
}

const TableCountRow = ({
  count, colSpan, text,
}: TableCountRowType): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <TableRow>
      <TableCell
        size={ style.size }
        colSpan={ colSpan }
        sx={ style.sx }
      >
        <Typography variant={ style.text.variant }>
          {
            count ?
              `${count} ${text}` :
              translate(STRING_KEYS.TABLE_ROW_NO_RESULT)
          }
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default TableCountRow;
